import { DefaultService } from '@/services/DefaultService';


export default class AssClienteEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assclienteempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllPromotor(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/promotor/empresa/assclienteempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assclienteempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assclienteempresa) {
        return this._http.post(`${this._env}/ven/empresa/assclienteempresa/updatesituacao`, assclienteempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoPromotor(assclienteempresa) {
        return this._http.post(`${this._env}/promotor/empresa/assclienteempresa/updatesituacao`, assclienteempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assclienteempresa) {
        return this._http.post(`${this._env}/agro/empresa/assclienteempresa/updatesituacao`, assclienteempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findClientesNaoAssociadosVendas(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assclienteempresa/clientesnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findClientesNaoAssociadosAgro(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assclienteempresa/clientesnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findClientesNaoAssociadosPromotor(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/promotor/empresa/assclienteempresa/clientesnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(listaclientes) {
        return this._http.post(`${this._env}/ven/empresa/assclienteempresa`, listaclientes, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    savePromotor(listaclientes) {
        return this._http.post(`${this._env}/promotor/empresa/assclienteempresa`, listaclientes, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(listaclientes) {
        return this._http.post(`${this._env}/agro/empresa/assclienteempresa`, listaclientes, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}